import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './user.state';
import { userFeatureKey } from './user.reducers';

export const selectUserState = createFeatureSelector<UserState>(userFeatureKey);

export const selectUser = createSelector(selectUserState, (state: UserState) => state);